import React from "react";
import dayjs, { Dayjs } from "dayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { Global, css } from "@emotion/react";

const hideYearPicker = css`
    div.MuiPickersCalendarHeader-label {
        display: none;
    }
    button.PrivatePickersYear-yearButton.Mui-selected {
        background-color: transparent !important;
        color: black !important;
    }
    button.PrivatePickersYear-yearButton.Mui-selected:hover {
        background-color: #f5f5f5 !important;
        color: black !important;
    }
`;

interface Props {
    defaultValue?: string;
    open?: boolean;
    autoFocus?: boolean;
    onClose?: () => void;
    onChange?: (date: string) => void;
    onAccept?: (value: Dayjs | null) => void;
    onChangeFormat?: string;
    label?: string;
}

const DatePicker = (props: Props) => {
    const [value, setValue] = React.useState<Dayjs | null>(
        dayjs(props.defaultValue || "")
    );
    const [showYear, setShowYear] = React.useState<boolean>(
        (props.defaultValue && props.defaultValue.length > 5) || false
    );

    const handleChange = (newValue: Dayjs | null) => {
        if (!newValue) return;
        setValue(newValue);
        if (props.onChangeFormat && props.onChange) {
            props.onChange(newValue.format(props.onChangeFormat));
            return;
        }
        const preFormatDate = newValue.format("D#M#YYYY").split("#");
        const formatDate = `${parseInt(preFormatDate[0]) - 1}#${
            parseInt(preFormatDate[1]) - 1
        }${showYear ? `#${preFormatDate[2]}` : ""}`;
        props.onChange && props.onChange(formatDate);
    };

    return (
        <>
            {!showYear && <Global styles={hideYearPicker} />}
            <MobileDatePicker
                className="salut"
                onAccept={props.onAccept}
                onYearChange={(a) => {
                    !showYear && setShowYear(true);
                    value &&
                        showYear &&
                        a.year() === value.year() &&
                        setShowYear(false);
                }}
                views={["day", "month", "year"]}
                label={props.label || "Birthday"}
                format={showYear ? "MM/DD/YYYY" : "MM/DD"}
                value={value}
                onClose={props.onClose}
                open={props.autoFocus}
                autoFocus={props.autoFocus}
                onChange={handleChange}
            />
        </>
    );
};

export default DatePicker;
